// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"c664dd4d","389":"1b237b30"}[chunkId] + ".chunk.css";
};